export default __webpack_public_path__ + "maps-examples-annotation-views-1200-005a4b592f7adb30a196e1b645dd5cb6.webp";